import axios from './client';

async function create(data) {
  return axios.post('/plan/partner/', data);
}

async function read(params) {
  return axios.get('/plan/partner/', { params });
}

async function update(data) {
  return axios.put(`/plan/partner/${data.id}/`, data);
}

async function remove(data) {
  return axios.delete(`/plan/partner/${data.id}/`);
}

export {
  create, read, update, remove,
};
